export default __webpack_public_path__ + "static/media/recherche_externe_icon.6f1652e3.svg";